import Vue from "vue";

export const getNews = ({ dispatch }) => {
  Vue.http.get("api/v1/News").then(function (response) {
    dispatch("NEWS_RECIEVED", response.data);
  });
};

export const changeNewsPage = ({ dispatch }, shift) => {
  dispatch("CHANGE_NEWS_PAGE", shift);
};



// WEBPACK FOOTER //
// ./src/views/home/HomeActions.js